import { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

// project imports
import Drawer from 'layout/Dashboard/Drawer';
import Footer from 'layout/Dashboard/Footer';
import AdminHeader from './AdminHeader';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import ScrollTop from 'components/ScrollTop';

import adminMenu from 'menu-items/admin';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { AdminModeProvider, useAdminMode } from 'contexts/AdminModeContext';

// ==============================|| ADMIN MAIN LAYOUT ||============================== //

export default function AdminLayout() {
  return (
    <AdminModeProvider>
      <AdminLayoutContent />
    </AdminModeProvider>
  );
}

function AdminLayoutContent() {
  const { mode, isLive } = useAdminMode();
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const drawerOpen = Boolean(menuMaster?.isDashboardDrawerOpened);
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  // Define abertura responsiva do drawer (aberto por padrão em desktop)
  useEffect(() => {
    handlerDrawerOpen(!downLG);
  }, [downLG]);

  const adminMenuItems = useMemo(() => ({ items: [adminMenu] }), []);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <ScrollTop />
      <AdminHeader />
      <Drawer menuItems={adminMenuItems} />

      <Box
        component="main"
        sx={{
          width: { xs: '100%', lg: drawerOpen ? 'calc(100% - 260px)' : 'calc(100% - 60px)' },
          flexGrow: 1,
          p: { xs: 2, sm: 3 }
        }}
      >
        <Toolbar sx={{ mt: 'inherit' }} />

        <Box
          sx={{
            ...{ px: { xs: 0, sm: 2 } },
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Breadcrumbs />
          {!isLive && (
            <Alert severity="warning" sx={{ mb: 2.5 }}>
              <strong>Modo Sandbox:</strong> está a ver dados de teste das empresas. Mude para Produção no topo da página.
            </Alert>
          )}
          {/* key={mode}: ao trocar Produção/Sandbox, a página remonta e recarrega os dados */}
          <Outlet key={mode} />
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}
